module.exports = __webpack_public_path__ + "img/logo-up-3.c947dc18.png";